import { render, staticRenderFns } from "./AddressWindow.vue?vue&type=template&id=4fd600c3&"
import script from "./AddressWindow.vue?vue&type=script&lang=js&"
export * from "./AddressWindow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports